export default __webpack_public_path__ + "static/media/kitchen3-afterI-1440w.58c01d9d.webp";